import pkg from "../../package.json";
export const LOCAL_APP_VERSION = pkg.version;
const VERSION_URL = "/version.json";
export const fetchRemoteAppVersion = async () => {
    try {
        const response = await fetch(`${VERSION_URL}?_=${Date.now()}`, {
            cache: "no-store",
            headers: { Accept: "application/json" },
        });
        if (!response.ok)
            return null;
        const data = (await response.json());
        if (!data?.version || typeof data.version !== "string")
            return null;
        return data;
    }
    catch (error) {
        console.warn("[PWA] No se pudo leer version.json remoto:", error);
        return null;
    }
};
export const clearPwaCaches = async () => {
    if (!("caches" in window))
        return;
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
};
export const forceServiceWorkerUpdate = async () => {
    if (!("serviceWorker" in navigator))
        return false;
    const registrations = await navigator.serviceWorker.getRegistrations();
    let foundWaiting = false;
    await Promise.all(registrations.map(async (registration) => {
        try {
            await registration.update();
        }
        catch (error) {
            console.warn("[PWA] registration.update falló:", error);
        }
        if (registration.waiting) {
            foundWaiting = true;
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
        }
    }));
    return foundWaiting;
};
/**
 * Compara la versión embebida del bundle con /version.json (sin cache).
 * Si hay diferencia, limpia caches del SW y recarga para tomar la build nueva.
 */
export const checkPwaVersionAndReload = async (options) => {
    const remote = await fetchRemoteAppVersion();
    if (!remote) {
        // Fallback: intentar update del SW y recargar si el usuario lo pidió
        await forceServiceWorkerUpdate();
        if (options?.forceReloadIfSame) {
            await clearPwaCaches();
            window.location.reload();
            return "updated";
        }
        return "unknown";
    }
    if (remote.version === LOCAL_APP_VERSION) {
        return "current";
    }
    console.info(`[PWA] Nueva versión detectada: local=${LOCAL_APP_VERSION} remota=${remote.version}`);
    await forceServiceWorkerUpdate();
    await clearPwaCaches();
    // Bust de navegación para evitar HTML/index cacheado
    const url = new URL(window.location.href);
    url.searchParams.set("_v", remote.version);
    window.location.replace(url.toString());
    return "updated";
};
export const setupPwaAutoUpdateCheck = () => {
    if (typeof window === "undefined")
        return () => { };
    let checking = false;
    const run = async () => {
        if (checking)
            return;
        if (document.visibilityState !== "visible")
            return;
        checking = true;
        try {
            await checkPwaVersionAndReload();
        }
        finally {
            checking = false;
        }
    };
    // Al volver a la app / pestaña
    const onVisibility = () => {
        void run();
    };
    document.addEventListener("visibilitychange", onVisibility);
    // Chequeo periódico (cada 15 min) mientras la PWA esté abierta
    const intervalId = window.setInterval(() => {
        void run();
    }, 15 * 60 * 1000);
    // Primera pasada al montar (ligera demora para no competir con el boot)
    const timeoutId = window.setTimeout(() => {
        void run();
    }, 2500);
    // Si el SW toma control con una versión nueva, recargar
    const onControllerChange = () => {
        window.location.reload();
    };
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);
    }
    return () => {
        document.removeEventListener("visibilitychange", onVisibility);
        window.clearInterval(intervalId);
        window.clearTimeout(timeoutId);
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange);
        }
    };
};
